// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const guzzlord: PokeData = {
  "id": 799,
  "name": "guzzlord",
  "height": 55,
  "weight": 8880,
  "base_experience": 257,
  "types": [
    PokeType.DARK,
    PokeType.DRAGON
  ],
  "api_moves": [
    "stomp",
    "body-slam",
    "thrash",
    "bite",
    "dragon-rage",
    "iron-tail",
    "crunch",
    "stockpile",
    "swallow",
    "knock-off",
    "hammer-arm",
    "wring-out",
    "gastro-acid",
    "dragon-rush",
    "giga-impact",
    "wide-guard",
    "heavy-slam",
    "dragon-tail",
    "steamroller",
    "belch",
    "brutal-swing",
    "stomping-tantrum"
  ],
  "moves": [
    "body-slam",
    "bite",
    "crunch",
    "dragon-rush",
    "dragon-vortex",
    "phantom-force",
    "dragon-claw",
    "draco-meteor",
    "night-daze",
    "dragon-dance",
    "quash",
    "dark-pulse",
    "lash-out"
  ],
  "evolution_chain": {
    "id": 420,
    "item": null,
    "species": [
      {
        "name": "guzzlord",
        "order": 799,
        "types": [
          PokeType.DARK,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 196,
    "speed": 61,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
